<template>
  <div>
    <t-form
      :onSubmit="submitShippingAddress"
      id="shipping_address_form"
      :schema="shippingAddressScema"
    >
      <div class="dashboard-row">
        <div class="input-title"><span>{{$translation($websiteText().my_profile_contact_person)}}</span></div>
        <div class="input-content">
          <div style='width:45%' playwright-id='shipping-first-name'>
            <t-input-text
              style="margin-right: 5px"
              v-model="shippingAddress.first_name"
              :modelValue="shippingAddress.first_name?shippingAddress.first_name:customer.first_name"
              :placeholder="$translation($websiteText().my_profile_first_name)"
              name="first_name"
              :disabled = 'disabled'
            ></t-input-text>
          </div>
          <div style='width:45%' playwright-id='shipping-last-name'>
            <t-input-text
              style=""
              v-model="shippingAddress.last_name"
              :modelValue="shippingAddress.last_name?shippingAddress.last_name:customer.last_name"
              :placeholder="$translation($websiteText().my_profile_last_name)"
              name="last_name"
              :disabled = 'disabled'
            ></t-input-text>
          </div>
        </div>
      </div>

      <div class="dashboard-row">
        <div class="input-title"><span>{{$translation($websiteText().my_profile_contact_email)}}</span></div>
        <div class="input-content" playwright-id="shipping-email">
          <t-input-text
            rootStyle="width:inherit"
            v-model="shippingAddress.email"
            :modelValue="shippingAddress.email?shippingAddress.email:customer.email"
            placeholder="example@email.com"
            name="email"
            :disabled = 'disabled'
          ></t-input-text>
        </div>
      </div>

      <div class="dashboard-row">
        <div class="input-title"><span>{{$translation($websiteText().my_profile_phone_number)}}*</span></div>
        <div class="input-content">
          <div style = "width:45%" playwright-id='shipping-phone-dial'>
            <t-input-select
              style="margin-right: 5px; "
              :options="$store.getters.phoneCodes"
              :filter="true"
              optionValue="dial_code"
              optionLabel="dial_code"
              v-model="shippingAddress.phone_dial"
              :displayError="true"
              optionLabel1="name"
              filterLabel="name"
              name="phone_dial"
              placeholder="+123"
              :disabled = 'disabled'
              :filterFields="['dial_code', 'name']"
            ></t-input-select>
          </div>
          <div style="width:45%" playwright-id='shipping-phone-number'>
            <t-input-text
              
              v-model="shippingAddress.phone_number"
              name="phone_number"
              :displayError="false"
              placeholder="01 23 45 67 89"
              :disabled = 'disabled'
            ></t-input-text>
          </div>
          
        </div>
      </div>
      
      <div class="dashboard-row">
        <div class="input-title"><span>{{$translation($websiteText().my_profile_address)}}</span></div>
        <div class="input-content" playwright-id='shipping-address'>
          <t-input-text
            rootStyle="width:inherit"
            id="locationTextField1"
            v-model="shippingAddress.address"
            :placeholder="$translation($websiteText().my_profile_address_placeholder)"
            name="address"
            style="width: 100%"
            :disabled = 'disabled'
            @input="init()"
            :autocomplete="'off'"
            :ariaAutocomplete="'none'"
          ></t-input-text>
        </div>
      </div>

      <div class="dashboard-row">
        <div class="input-title"><span>{{$translation($websiteText().my_profile_company)}}</span></div>
        <div class="input-content" playwright-id='shipping-company'>
          <t-input-text
            rootStyle="width:inherit"
            v-model="shippingAddress.company_name"
            :placeholder="$translation($websiteText().my_profile_company)"
            name="company_name"
            :disabled = 'disabled'
          ></t-input-text>
        </div>
      </div>

      <div class="dashboard-row">
        <div class="input-title"><span>{{$translation($websiteText().my_profile_street)}}</span></div>
        <div class="input-content" playwright-id='billing-street'>
          <t-input-text
            rootStyle="width:inherit"
            v-model="shippingAddress.street_name"
            name="street_name"
            :placeholder="$translation($websiteText().my_profile_street)"
            :disabled = 'disabled'
          ></t-input-text>
        </div>
      </div>

      <div class="dashboard-row">
        <div class="input-title"><span>{{$translation($websiteText().my_profile_zip)}}</span></div>
        <div class="input-content" playwright-id='shipping-zip-code'>
          <t-input-text
            rootStyle="width:inherit"
            v-model="shippingAddress.zip"
            name="zip"
            :placeholder="$translation($websiteText().my_profile_zip)"
            :disabled = 'disabled'
          ></t-input-text>
        </div>
      </div>
      <div class="dashboard-row">
        <div class="input-title"><span>{{$translation($websiteText().my_profile_country)}}</span></div>
        <div class="input-content" playwright-id='billing-country'>
          <!-- <t-input-text
            rootStyle="width:inherit"
            v-model="billingAddress.country"
            name="country"
            :placeholder="$translation($websiteText().my_profile_country)"
            :disabled='false'
          ></t-input-text> -->

          <t-input-select
            style="margin-right: 5px;"
            :options="$store.getters.apiCountries"
            :filter="true"
            optionValue="name"
            v-model="shippingAddress.country"
            :displayError="true"
            optionLabel1="iso2"
            filterLabel='name'
            name="country"
            :placeholder="$translation($websiteText().my_profile_country)"
            :disabled = 'false'
            :filterFields="['iso2', 'name']"
            :changeAction="getStates"
            
          ></t-input-select>
        </div>
      </div>
      <div class="dashboard-row">
        <div class="input-title"><span>{{$translation($websiteText().my_profile_state)}}</span></div>
        <div class="input-content" playwright-id='billing-state'>
          <!-- <t-input-text
            rootStyle="width:inherit"
            v-model="billingAddress.state"
            name="state"
            :placeholder="$translation($websiteText().my_profile_state)"
            :disabled = 'false'
          ></t-input-text> -->
          <t-input-select
            style="margin-right: 5px;"
            :options="$store.getters.statesByCountry"
            :filter="true"
            optionValue="name"
            v-model="shippingAddress.state"
            :displayError="true"
            optionLabel1="iso2"
            filterLabel='name'
            name="state"
            :placeholder="$translation($websiteText().my_profile_state)"
            :disabled = 'false'
            :filterFields="['iso2', 'name']"
            :changeAction="getCities"
          ></t-input-select>
        </div>
      </div>
      <div class="dashboard-row">
        <div class="input-title"><span>{{$translation($websiteText().my_profile_city)}}</span></div>
        <div class="input-content" playwright-id='billing-city'>
          <!-- <t-input-text
            rootStyle="width:inherit"
            v-model="billingAddress.city"
            name="city"
            :placeholder="$translation($websiteText().my_profile_city)"
            :disabled = 'false'
          ></t-input-text> -->

          <t-input-select
            style="margin-right: 5px;"
            :options="$store.getters.citiesbyState"
            :filter="true"
            optionValue="name"
            v-model="shippingAddress.city"
            :displayError="true"
            optionLabel1="iso2"
            filterLabel='name'
            name="city"
            :placeholder="$translation($websiteText().my_profile_city)"
            :disabled = 'false'
            :filterFields="['name']"
            
          ></t-input-select>
        </div>
      </div>     
      <div class="dashboard-row" style="">
        <div class="input-title">{{$translation($websiteText().my_profile_additional_info)}}</div>
        <div class="input-content" playwright-id='additional'>
          <t-textarea
            style="width: 100%"
            :placeholder="$translation($websiteText().my_profile_additional_info)"
            :rows="3"
            v-model="shippingAddress.additional_info"
            :disabled="false"
            name="Additional"
            :autoResize="true"
          />
        </div>
      </div>
      <div class="dashboard-row" v-if="showSubmit" playwright-id='shipping-save-button'>
        <t-button
          style="margin-left: auto"
          :label="$translation($websiteText().website_generals_save_btn)"
          formSubmit="shipping_address_form"
          type="submit"
          :onClick="submitShippingValidate"
          :color="'primary-color'"
        />
      </div>
    </t-form>
  </div>
</template>

<script>
import store from "../../../../store";
import * as Yup from "yup";
import { reactive } from "@vue/reactivity";
import TInputText from "../../../../common/components/input-text/TInputText.vue";
import TTextarea from "../../../../common/components/input-text/TTextarea.vue";
import TInputSelect from "../../../../common/components/input-text/TInputSelect.vue";
import TForm from "../../../../common/components/TForm.vue";
import TButton from "../../../../common/components/buttons/TButton.vue";
import {
  UPDATE_SHIPPING_ADDRESS,
  CREATE_SHIPPING_ADDRESS,
} from "../../store/customer/actions";

import GooglePlacesHelper from "../../../../common/helpers/GooglePlacesHelper";
import { SET_API_COUNTRIES, SET_CITIES_BY_STATES, SET_STATES_BY_COUNTRY, SHOW_TOAST_MESSAGE } from "../../../../common/store/actions";
import GeneralHelper from "../../../../common/helpers/GeneralHelper";
import phoneCodes from "../../../../common/store/phoneCodes";

export default {
  components: { TInputText, TInputSelect, TForm, TButton, TTextarea },

  data() {
    return {
      countries:[],
      countryIso2: null,
      states:[],
      cities: [],
    }
  },
  mounted() {
    this.$store.dispatch(SET_API_COUNTRIES).then(()=>{
      this.countries = this.$store.getters.apiCountries;
      
    })
    // this.init();
  },

  methods: {
    getStates(countryName) {
    
      const country = this.countries.find(c => c.name === countryName);
      if (!country) return;
      this.countryIso2 = country.iso2;
      return this.$store.dispatch(SET_STATES_BY_COUNTRY, country.iso2).then(() => {
        this.states = this.$store.getters.statesByCountry;
        
      });
    },

    getCities(stateName){
 
      const state = this.states.find(s => s.name === stateName);
      
      if (!state) return;
      return this.$store.dispatch(SET_CITIES_BY_STATES, {
        countryCode: this.countryIso2,
        stateCode: state.iso2
      }).then(() => {
        this.cities = this.$store.getters.citiesbyState;
        console.log("cities", this.cities);
      });
    }

    
  },
  watch: {
    'shippingAddress.country': async function (newValue, oldValue) {
      await this.getStates(newValue);
    },

    'shippingAddress.state': async function (newValue, oldValue) {
      await this.getStates(this.shippingAddress.country);
      this.getCities(newValue);
    },
  },
  computed: {
  customer() {
      return this.$store.getters.customer;
    }
  },
  setup(props, { emit }) {
    let shippingAddress =
      props.data_ != undefined ? reactive(props.data_) : reactive({});
    let autocomplete = null;

    const init = () => {
      var input = document.getElementById("locationTextField1");
      if(!autocomplete) 
      {
        autocomplete = new google.maps.places.Autocomplete(input)
        console.log(autocomplete)
        google.maps.event.addListener(autocomplete, "place_changed", function() {
          var place = autocomplete.getPlace();
          if (place.business_status) {
            shippingAddress.company_name = place.name
          }
          if(place.international_phone_number){
            for(var i = 0; i < place.address_components.length; i++) {
              var addressObj = place.address_components[i];
              for(var j = 0; j < addressObj.types.length; j++) {
                if (addressObj.types[j] === 'country') {
                  shippingAddress.phone_dial = phoneCodes.find(phoneCode=>phoneCode.name==addressObj.long_name).dial_code
                  shippingAddress.phone_number = place.formatted_phone_number
                  break
                }
              }
            } 
          }
          var details = GooglePlacesHelper.extract(place.address_components);
          console.log("details", details);

          billingAddress.street_name = (details.route||"").trim();
          billingAddress.country = (details.country||"").trim();
          billingAddress.zip = (details.zip||"").trim();
          billingAddress.address = (place.formatted_address||"").trim()

        store.dispatch(SET_API_COUNTRIES).then(() => {
          const countries = store.getters.apiCountries;
          const country = countries.find((c) => c.name === details.country);
          console.log("country", country);

          if (!country) return;

          const countryIso2 = country.iso2;
          billingAddress.country = country.name;

          store.dispatch(SET_STATES_BY_COUNTRY, countryIso2).then(() => {
            const states = store.getters.statesByCountry;
            console.log("states", states);
            billingAddress.state = (details.state || "").trim();

            const state = states.find((s) => s.name === details.state);
            if (!state) return;

            store
              .dispatch(SET_CITIES_BY_STATES, {
                countryCode: countryIso2,
                stateCode: state.iso2,
              })
              .then(() => {
                const cities = store.getters.citiesbyState;
                console.log("cities", cities);
                billingAddress.city = (details.city || "").trim();
              });
          });
        });
        });

        input.addEventListener('blur', function (){
          setTimeout(function (){
  
            var service = new google.maps.places.AutocompleteService();
            service.getPlacePredictions({ input: input.value }, predictionsCallback);
            function predictionsCallback(predictions, status) {
              if (status != google.maps.places.PlacesServiceStatus.OK) return;
              
              let place_id = predictions[0].place_id
              const geocoder = new google.maps.Geocoder();
              geocoder
              .geocode({ placeId: place_id })
              .then(({ results }) => {
                if (results[0]) {
                  var details = GooglePlacesHelper.extract(results[0].address_components);
                  shippingAddress.street_name = (details.route||"").trim();
                  shippingAddress.country = (details.country||"").trim();
                  shippingAddress.zip = (details.zip||"").trim();
                  shippingAddress.state = (details.state||"").trim();
                  shippingAddress.city = (details.city||"").trim();
                  shippingAddress.address = (results[0].formatted_address||"").trim()
                } else {
                  window.alert("No results found");
                }
              })
              .catch((e) => window.alert("Geocoder failed due to: " + e));

              }
                      
          }, 500);
          
        })
      }
    };
    const submitShippingValidate = () => {
      shippingAddressScema
        .validate(shippingAddress, { abortEarly: false })
        .then()
        .catch((e) => {
          for (let i = 0; i < e.errors.length; i++) {
            store.dispatch(
              SHOW_TOAST_MESSAGE,
              GeneralHelper.buildMessage(3, e.errors[i])
            );
          }
        });
    };
    const shippingAddressScema = Yup.object().shape({
      first_name: Yup.string()
        .required()
        .label("First name"),
      last_name: Yup.string()
        .required()
        .label("Last name"),
      email: Yup.string()
        .required()
        .email("Invalid email format")
        .label("Email"),
      phone_dial: Yup.string()
        .required()
        .label("Phone dial"),
      phone_number: Yup.string()
        .required()
        .label("Phone number"),
      address: Yup.string()
        .required()
        .label("Address"),
      city: Yup.string()
        .required()
        .label("City"),
      country: Yup.string()
        .required()
        .label("Country"),
      street_name: Yup.string()
        .required()
        .label("Street"),
      zip: Yup.string()
        .required()
        .label("ZIP Code"),
    });

    const submitShippingAddress = () => {
      shippingAddressScema.isValid(shippingAddress).then(function(valid) {
        if (!props.showSubmit) emit("validated", valid);
      });
      if (props.showSubmit) {
        if (shippingAddress.id != undefined)
          store
            .dispatch(UPDATE_SHIPPING_ADDRESS, shippingAddress)
            .then()
            .catch((e) => {
              if (e.response && e.response.data) {
                store.dispatch(
                  SHOW_TOAST_MESSAGE,
                  GeneralHelper.buildMessage(3, e.response.data.message)
                );
              }
            });
        else
          store
            .dispatch(CREATE_SHIPPING_ADDRESS, shippingAddress)
            .then(() => {})
            .catch((e) => {
              if (e.response && e.response.data) {
                store.dispatch(
                  SHOW_TOAST_MESSAGE,
                  GeneralHelper.buildMessage(3, e.response.data.message)
                );
              }
            });
      }
    };

    return {
      submitShippingValidate,
      shippingAddressScema,
      submitShippingAddress,
      shippingAddress,
      init,
    };
  },

  props: {
    showSubmit: {
      Type: Boolean,
      default: true,
    },
    data_: Object,
    disabled:{
      Type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
@import '../../style/profile.scss';
</style>
